import { isAxiosError } from "./client";
import { createApiClientErrorFromApiResponse, createApiClientErrorFromAxios, createNoDataReceivedError, } from "./api-client-error";
function ensureResponseData(data) {
    if (data === undefined) {
        throw createNoDataReceivedError();
    }
    return data;
}
export async function requestApiResponse(request, options) {
    try {
        const response = await request();
        const data = ensureResponseData(response.data);
        const apiResponse = options?.validateApiResponse?.(data);
        if (apiResponse?.success === false) {
            throw createApiClientErrorFromApiResponse(apiResponse);
        }
        return data;
    }
    catch (error) {
        if (isAxiosError(error)) {
            throw createApiClientErrorFromAxios(error);
        }
        throw error;
    }
}
